import { sameSettingsValue } from "../grouped-settings-changes";

/**
 * Settings for a tab are one object of named groups, and a save sends only the
 * fields that changed. Each tab diffs and merges its groups the same way.
 */
export type SettingsGroups = Record<string, Record<string, unknown>>;

export function diffSettingsGroups(
  groupKeys: readonly string[],
  initial: SettingsGroups,
  next: SettingsGroups,
): SettingsGroups {
  const changes: SettingsGroups = {};
  for (const group of groupKeys) {
    const initialGroup = initial[group] ?? {};
    const nextGroup = next[group] ?? {};
    for (const [field, value] of Object.entries(nextGroup)) {
      if (!sameSettingsValue(initialGroup[field], value)) {
        changes[group] = { ...changes[group], [field]: value };
      }
    }
  }
  return changes;
}

export function mergeSettingsGroups(
  groupKeys: readonly string[],
  base: SettingsGroups,
  changes: SettingsGroups,
): SettingsGroups {
  return Object.fromEntries(
    groupKeys.map((group) => [group, { ...base[group], ...changes[group] }]),
  );
}
